import { render, staticRenderFns } from "./Pensionables.vue?vue&type=template&id=773ec21b&"
import script from "./Pensionables.vue?vue&type=script&lang=js&"
export * from "./Pensionables.vue?vue&type=script&lang=js&"
import style0 from "./Pensionables.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports